/**
 * 媒体相关请求
 */
import request from '../request'
import apis from '../apis'
export default {
    // 获取接口人W3账号
    findOrgCfgUserList(params) {
        return request.get(apis.GET_USER_ACCOUNT_LIST, { params });
    }
}
